<template>
  <div>
    <div>
      <div style="margin-top: 50px">
        <p class="open-sans-20pt">
          Moja naročila
        </p>
      </div>
      <div v-show="prikazTabele === '1'" style="clear: both" v-loading="nalaganjeZgodovineNakupov">
        <div v-if="seznamPodatkovZgodovineNarocil.length === 0"
             class="prikaz-narocil">
          <p>
            Ni naročil za prikaz.
          </p>
        </div>
        <div v-else class="prikaz-narocil">
          <el-table
            style="width: 100%;"
            empty-text="Ni podatkov"
            :data="seznamPodatkovZgodovineNarocil"
            :expand-row-keys="expandRowKeys"
            :row-key="row => row.idNarocilo"
            @expand-change="IzbiraVrsticeZaPrikazPodatkov">
            <el-table-column prop="datum" sortable label="Datum naročila" width="200px"></el-table-column>
            <el-table-column label="Naziv" :width="sirinaDesktopTabele">
              <template slot-scope="scope">
                {{ scope.row.naziv }}
              </template>
            </el-table-column>
            <el-table-column prop="tocke" label="Število porabljenih točk"></el-table-column>
            <el-table-column type="expand">
              <template slot-scope="scope">
                <div style="padding: 0 50px 0 0;">
                  <div class="container">
                    <div style="display: flex; align-items: center; width: 178px;">
                      <img src="/static/img/Domov/NoPath2x.png">
                    </div>
                    <div style="padding-bottom: 60px; padding-top: 25px">
                      <MojaNarocilaAtribut :narocilo="scope.row" atribut="naziv"
                                           atribut-naziv="" dodaten-stil="padding-bottom: 20px"/>
                      <MojaNarocilaAtribut :narocilo="scope.row" atribut="prikljucek"
                                           atribut-naziv="Naročilo na priključek"/>
                      <MojaNarocilaAtribut :narocilo="scope.row" atribut="tocke"
                                           atribut-naziv="Število porabljenih točk"/>
                      <MojaNarocilaAtribut :narocilo="scope.row" atribut="nacinPlacila"
                                           atribut-naziv="Način plačila"/>
                      <MojaNarocilaAtribut :narocilo="scope.row" atribut="obrokiPlacano"
                                           atribut-naziv="Število plačanih obrokov"/>
                      <MojaNarocilaAtribut :narocilo="scope.row" atribut="obrokiZaPlacat"
                                           atribut-naziv="Število obrokov za plačilo"/>
                      <MojaNarocilaAtribut :narocilo="scope.row" atribut="naslovZaDostavo"
                                           atribut-naziv="Naslov za dostavo"/>

<!--                      ZAKOMENTIRANO ZA KASNEJSO UPORABO-->
<!--                      <div v-if="prikaziUrejanjeNaslova === false && naslovZaDostavo !== '' &&-->
<!--                                             hisnaStZaDostavo !== ''">-->
<!--                        Naslov za dostavo:-->
<!--                        <span>-->
<!--                          <b>-->
<!--                            {{ naslovZaDostavo }}-->
<!--                          </b>-->
<!--                        </span>-->
<!--                        <a v-if="dovoljenaSpremembaKontakta === 1" @click="UrejanjeNaslova()"-->
<!--                           style="cursor: pointer">-->
<!--                          <img src="/static/img/MojT2/T2Klub/Icon-material-edit.png">-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div v-if="prikaziUrejanjeNaslova === true" style="padding-top: 10px;-->
<!--                                                        padding-bottom: 50px">-->
<!--                        <div class="podatki">-->
<!--                          <div>-->
<!--                            <p>-->
<!--                              Naslov-->
<!--                            </p>-->
<!--                            <el-select @change="PreverjanjeNaslova()"-->
<!--                                       :remote-method="PredlaganiStalenNaslov"-->
<!--                                       filterable-->
<!--                                       placeholder="Vnesite naslov"-->
<!--                                       remote-->
<!--                                       allow-create-->
<!--                                       reserve-keyword-->
<!--                                       no-data-text="Ni podatkov"-->
<!--                                       class="velikost-input"-->
<!--                                       size="small"-->
<!--                                       v-model="naslovZaDostavo">-->
<!--                              <el-option v-for="item in naslovi" :key="item" :label="item" :value="item">-->
<!--                              </el-option>-->
<!--                            </el-select>-->
<!--                          </div>-->
<!--                          <div>-->
<!--                            <p>-->
<!--                              Hišna številka-->
<!--                            </p>-->
<!--                            <el-input type="text"-->
<!--                                      v-model="hisnaStZaDostavo"-->
<!--                                      maxlength="7"-->
<!--                                      size="small"-->
<!--                                      placeholder="Vnesite hišno številko"-->
<!--                                      class="velikost-input">-->
<!--                            </el-input>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                        <div style="float: right">-->
<!--                          <a style="float: right;" class="gumb-preklici" @click="PrekliciUrejanjeNaslova">-->
<!--                            Prekliči-->
<!--                          </a>-->
<!--                          <el-button type="primary" class="gumb-potrdi gumb-potrdi-sirina"-->
<!--                                     @click="PosodobitKontaktZaDostavo">-->
<!--                            Dodaj naslov-->
<!--                          </el-button>-->
<!--                        </div>-->
<!--                      </div>-->

                      <MojaNarocilaAtribut :narocilo="scope.row" atribut="statusNarocila"
                                           atribut-naziv="Status naročila"/>
                      <MojaNarocilaAtribut :narocilo="scope.row" atribut="dostava"
                                           atribut-naziv="Status dostave"/>
                      <br/>
                      <div style="width: 270px">
                        <div style="" v-if="scope.row.prikazPogodbe">
                          <span>
                            <img src="../../../../../../static/img/MojT2/T2Klub/Icon-awesome-file-pdf.png"/>
                            <a href="javascript:void(0)" @click="PridobiPogodbo(scope.row.idNarocilo)"
                               class="primarna-barva">
                              Pogodba/aneks
                            </a>
                          </span>
                        </div>
                      </div>
                      <div style="clear: both"/>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div v-show="prikazTabele === '0'  && nalaganjeZgodovineNakupov === false" v-loading="nalaganjeZgodovineNakupov">
        <div>
          <el-table
            :data="seznamPodatkovZgodovineNarocil"
            empty-text="Ni podatkov"
            :expand-row-keys="expandRowKeys"
            :row-key="row => row.idNarocilo"
            @expand-change="IzbiraVrsticeZaPrikazPodatkov">
            <el-table-column
              label="Naziv">
              <template slot-scope="scope">
                {{ scope.row.naziv }}
              </template>
            </el-table-column>
            <el-table-column type="expand">
              <template slot-scope="scope">
                <div style="padding: 20px" class="container">
                  <div>
                    <div>
                      <MojaNarocilaAtribut :narocilo="scope.row" atribut="naziv" atribut-naziv="" />
                      <MojaNarocilaAtribut :narocilo="scope.row" atribut="prikljucek"
                                           atribut-naziv="Naročilo na priključek"/>
                      <MojaNarocilaAtribut :narocilo="scope.row" atribut="tocke"
                                           atribut-naziv="Število porabljenih točk"/>
                      <MojaNarocilaAtribut :narocilo="scope.row" atribut="nacinPlacila"
                                           atribut-naziv="Način plačila"/>
                      <MojaNarocilaAtribut :narocilo="scope.row" atribut="datum" atribut-naziv="Datum naročila"/>
                      <MojaNarocilaAtribut :narocilo="scope.row" atribut="obrokiPlacano"
                                           atribut-naziv="Število plačanih obrokov"/>
                      <MojaNarocilaAtribut :narocilo="scope.row" atribut="obrokiZaPlacat"
                                           atribut-naziv="Število obrokov za plačilo"/>
                      <MojaNarocilaAtribut :narocilo="scope.row" atribut="naslovZaDostavo"
                                           atribut-naziv="Naslov za dostavo"/>
                      <MojaNarocilaAtribut :narocilo="scope.row" atribut="statusNarocila"
                                           atribut-naziv="Status naročila"/>
                      <MojaNarocilaAtribut :narocilo="scope.row" atribut="dostava"
                                           atribut-naziv="Status dostave"/>

                      <br/>
                      <div v-if="scope.row.prikazPogodbe">
                        <span>
                          <a href="javascript:void(0)" @click="PridobiPogodbo(scope.row.idNarocilo)"
                             class="primarna-barva">
                              Pogodba/aneks
                          </a>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="text-center" style="cursor: pointer;">
        <el-pagination
          :hide-on-single-page="true"
          @current-change="PrikaziStraniZgodovineNarocilKlub"
          :page-size="4"
          layout="prev, pager, next"
          :total="dolzinaSeznamaZgodovineTransakcij"
          :current-page="trenutnoIzbranaStranZgodovinanarocil"
          small>
        </el-pagination>
      </div>
    </div>

    <div class="odmik-zgodovina-tock">
      <div>
        <p class="open-sans-20pt">
          Zgodovina prejetih točk
        </p>
      </div>
      <p class="navadno-besedilo odmik-text-zgodovina-tock">
        Točke pridobivate z vsakim nakupom izdelkov in storitev v T-2 spletni trgovini.
        <br/>
        Naročniki storitev T-2 točke pridobite tudi z vsakim plačanim računom in z vsakim mesecem zvestobe.
      </p>
      <div v-show="prikazTabele === '1'">
        <div v-if="seznamPodatkovTransakcij.length === 0" class="prikaz-narocil">
          <p class="primarna-barva-pisave">
            Ni zgodovine prejetih točk.
          </p>
        </div>
        <div v-else>
          <el-table
            :data="seznamPodatkovTransakcij"
            empty-text="Ni podatkov"
            :default-sort="{prop: 'datum'}"
            style="width: 100%"
            v-loading="nalaganjeZadnjeTransakcije">
            <el-table-column prop="datum" sortable label="Datum" width="200px"></el-table-column>
            <el-table-column prop="razlog" label="Opis" :width="sirinaDesktopTabele"> </el-table-column>
            <el-table-column label="Točke">
              <template slot-scope="scope">
                {{ scope.row.stTock }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div v-show="prikazTabele === '0'">
        <el-table
          :data="seznamPodatkovTransakcij"
          empty-text="Ni podatkov"
          :default-sort="{prop: 'datum', order: 'descending'}"
          v-loading="nalaganjeZadnjeTransakcije">
          <el-table-column>
            <template slot-scope="props">
              <MojaNarocilaParagraf :narocilo="props.row" atributNaziv="Datum" atribut="datum"/>
              <MojaNarocilaParagraf :narocilo="props.row" atributNaziv="Opis" atribut="razlog" />
              <MojaNarocilaParagraf :narocilo="props.row" atributNaziv="Točke" atribut="stTock" />
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="text-center" style="cursor: pointer;">
        <br/>
        <el-pagination
          :hide-on-single-page="true"
          @current-change="PrikaziStraniZgodovineTockKlub"
          :current-page="trenutnoIzbranaStran"
          :page-size="4"
          layout="prev, pager, next"
          :total="dolzinaSeznamaTransakcij"
          small>
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import Validacija from 'src/assets/js/globalne_funkcije/Validacija.js'
import ClientAgent from '../../../../../assets/js/clientAgent.js'
import {PrikazVsebine} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js'
import {
  Checkbox, Button, Option, Select, Pagination, TabPane, Tabs, Input, Table, TableColumn,
  FormItem, Form, Row
} from 'element-ui'
import MojaNarocilaAtribut from './MojaNarocilaInfo/MojaNarocilaAtribut'
import MojaNarocilaParagraf from './MojaNarocilaInfo/MojaNarocilaParagraf'
import {PrenosDatoteke} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/PrenosDatoteke'

export default {
  name: 'MojaNarocila',
  mixins: [PrikazVsebine, PrenosDatoteke],
  data () {
    return {
      seznamPodatkovZgodovineNarocil: [],
      seznamPodatkovTransakcij: [],
      nalaganjeZgodovineNakupov: true,
      nalaganjeZadnjeTransakcije: false,
      trenutnoIzbranaStran: 1,
      expandRowKeys: [],
      trenutnoIzbranaStranZgodovinanarocil: 1,
      dolzinaSeznamaTransakcij: 0,
      dolzinaSeznamaZgodovineTransakcij: 0,
      naziv: '',
      prikljucek: '',
      naslovZaDostavo: '',
      hisnaStZaDostavo: '',
      dovoljenaSpremembaKontakta: '',
      idNarocilo: '',
      imeZaDostavo: '',
      priimekZaDostavo: '',
      naslovi: [],
      seznamZgodovineNakupov: [],
      prikaziUrejanjeNaslova: false,
      sirinaDesktopTabele: 600
    }
  },
  props: {
    izbranaStranka: String,
    vclanjen: Boolean,
    osnovniSeznamZgodovineNakupov: Array,
    osnovniSeznamZgodovineTock: Array
  },
  components: {
    MojaNarocilaAtribut,
    MojaNarocilaParagraf,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
    [Option.name]: Option,
    [Select.name]: Select,
    [Pagination.name]: Pagination,
    [TabPane.name]: TabPane,
    [Tabs.name]: Tabs,
    [Input.name]: Input,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [FormItem.name]: FormItem,
    [Form.name]: Form,
    [Row.name]: Row
  },
  watch: {
    osnovniSeznamZgodovineNakupov: function () {
      this.PridobiPodatkeZgodovineNarocilKlub()
    },
    osnovniSeznamZgodovineTock: function () {
      this.PridobiPodatkeZgodovineTockKlub()
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.validacija = new Validacija()
    this.$nextTick(function () {
      window.addEventListener('resize', this.PrilagodiSirinoDesktopTabele())
      window.dispatchEvent(new Event('resize'))
    })
  },
  updated: function () {
    this.$nextTick(function () {
      if (this.nalaganjeZgodovineNakupov === false && this.seznamPodatkovZgodovineNarocil.length > 0) {
        let vmesnik = this
        setTimeout(function () {
          vmesnik.PrilagodiSirinoDesktopTabele()
        }, 200)
      }
    })
    window.addEventListener('resize', this.PrilagodiSirinoDesktopTabele)
  },
  methods: {
    PrilagodiSirinoDesktopTabele () {
      if (document.documentElement.clientWidth < 1530) {
        this.sirinaDesktopTabele = 500
      } else if (document.documentElement.clientWidth < 1600) {
        this.sirinaDesktopTabele = 600
      } else {
        this.sirinaDesktopTabele = 700
      }
    },
    UrejanjeNaslova () {
      this.prikaziUrejanjeNaslova = true
    },
    PrekliciUrejanjeNaslova () {
      this.prikaziUrejanjeNaslova = false
    },
    IzbiraVrsticeZaPrikazPodatkov (row, expandedRows) {
      this.naslovZaDostavo = ''
      this.hisnaStZaDostavo = ''
      const id = row.idNarocilo
      const lastId = this.expandRowKeys[0]
      this.expandRowKeys = id === lastId ? [] : [id]
      if (expandedRows.length > 0) {
        let podatkiNarocila = row
        if (typeof podatkiNarocila.naslovZaDostavo !== 'undefined') {
          this.naslovZaDostavo = podatkiNarocila.naslovZaDostavo
        }
        if (typeof podatkiNarocila.hisnaStZaDostavo !== 'undefined') {
          this.hisnaStZaDostavo = podatkiNarocila.hisnaStZaDostavo
        }
        if (typeof podatkiNarocila.dovoljenaSpremembaKontakta !== 'undefined') {
          this.dovoljenaSpremembaKontakta = podatkiNarocila.dovoljenaSpremembaKontakta
        }
        if (typeof podatkiNarocila.idNarocilo !== 'undefined') {
          this.idNarocilo = podatkiNarocila.idNarocilo
        }
        if (typeof podatkiNarocila.imeZaDostavo !== 'undefined') {
          this.imeZaDostavo = podatkiNarocila.imeZaDostavo
        }
        if (typeof podatkiNarocila.priimekZaDostavo !== 'undefined') {
          this.priimekZaDostavo = podatkiNarocila.priimekZaDostavo
        }
      }
    },
    PridobiPodatkeZgodovineNarocilKlub () {
      this.nalaganjeZgodovineNakupov = true
      let tmpArray = []
      this.dolzinaSeznamaZgodovineTransakcij = this.osnovniSeznamZgodovineNakupov.length
      const chunk = 4
      for (let i = 0; i < this.dolzinaSeznamaZgodovineTransakcij; i += chunk) {
        let podatkiNarocil = this.osnovniSeznamZgodovineNakupov.slice(i, i + chunk)
        for (const j in podatkiNarocil) {
          if (typeof podatkiNarocil[j].postavke !== 'undefined' && podatkiNarocil[j].postavke.length) {
            let jeNarocenKomplet = false
            for (let k = 0; k < podatkiNarocil[j].postavke.length; k++) {
              if (podatkiNarocil[j].postavke[k].komplet === 1) {
                jeNarocenKomplet = true
                break
              }
            }
            for (let k = 0; k < podatkiNarocil[j].postavke.length; k++) {
              if (!jeNarocenKomplet || (jeNarocenKomplet && podatkiNarocil[j].postavke[k].komplet === 1)) {
                podatkiNarocil[j].naziv = podatkiNarocil[j].postavke[k].naziv
              }
              podatkiNarocil[j].tocke = podatkiNarocil[j].postavke[k].tocke
              podatkiNarocil[j].nacinPlacila = podatkiNarocil[j].postavke[k].nacinPlacila
              if (typeof podatkiNarocil[j].ulicaZaDostavo !== 'undefined' &&
                typeof podatkiNarocil[j].hisnaStZaDostavo !== 'undefined' &&
                typeof podatkiNarocil[j].pStZaDostavo !== 'undefined' &&
                typeof podatkiNarocil[j].postaZaDostavo !== 'undefined') {
                podatkiNarocil[j].naslovZaDostavo = podatkiNarocil[j].ulicaZaDostavo + ' ' +
                podatkiNarocil[j].hisnaStZaDostavo + ', ' + podatkiNarocil[j].pStZaDostavo + ' ' +
                podatkiNarocil[j].postaZaDostavo
              }
              podatkiNarocil[j].prikazPogodbe = podatkiNarocil[j].obstajaPogodba === 1
            }
          }
        }
        tmpArray.push(podatkiNarocil)
      }
      this.seznamZgodovineNakupov = tmpArray
      this.PrikaziStraniZgodovineNarocilKlub(1)
    },
    PrikaziStraniZgodovineNarocilKlub (stran) {
      this.trenutnoIzbranaStranZgodovinanarocil = stran
      if (typeof this.seznamZgodovineNakupov[this.trenutnoIzbranaStranZgodovinanarocil - 1] !== 'undefined') {
        this.seznamPodatkovZgodovineNarocil =
          this.seznamZgodovineNakupov[this.trenutnoIzbranaStranZgodovinanarocil - 1]
      } else {
        this.seznamPodatkovZgodovineNarocil = []
      }
      this.nalaganjeZgodovineNakupov = false
    },
    PridobiPodatkeZgodovineTockKlub () {
      this.nalaganjeZadnjeTransakcije = true
      let tmpArray = []
      this.dolzinaSeznamaTransakcij = this.osnovniSeznamZgodovineTock.length
      const chunk = 4
      for (let i = 0; i < this.dolzinaSeznamaTransakcij; i += chunk) {
        tmpArray.push(this.osnovniSeznamZgodovineTock.slice(i, i + chunk))
      }
      this.seznamTransakcij = tmpArray
      this.PrikaziStraniZgodovineTockKlub(1)
    },
    PrikaziStraniZgodovineTockKlub (stran) {
      this.trenutnoIzbranaStran = stran
      if (typeof this.seznamTransakcij[this.trenutnoIzbranaStran - 1] !== 'undefined') {
        this.seznamPodatkovTransakcij = this.seznamTransakcij[this.trenutnoIzbranaStran - 1]
      } else {
        this.seznamPodatkovTransakcij = []
      }
      this.nalaganjeZadnjeTransakcije = false
    },
    PosodobitKontaktZaDostavo () {
      if (this.izbranaStranka !== '') {
        if (!this.validacija.HisnaStevilkaValidation(this.hisnaStZaDostavo)) {
          let paramObvestilo = {}
          paramObvestilo.message = 'Vpisali ste hišno številko ki je še nimamo zabeležene v sistemu. Prosimo,' +
            'preverite vpisano številko.'
          this.ShowWarningMessage(paramObvestilo)
        }
        if (!this.validacija.PreverjanjeNaslova(this.naslovZaDostavo)) {
          let paramObvestilo = {}
          paramObvestilo.message = 'Vpisali ste napačen naslov. Prosimo, poskusite ponovno.'
          this.ShowWarningMessage(paramObvestilo)
        }
        let param = ['idStranka=' + this.izbranaStranka]
        param.push('idNarocilo=' + this.idNarocilo)
        param.push('ime=' + this.imeZaDostavo)
        param.push('priimek=' + this.priimekZaDostavo)
        param.push('ulicaNaziv=' + this.naslovZaDostavo)
        param.push('hisnaSt=' + this.hisnaStZaDostavo)
        this.clientAgent.postWsRequest(this,
          'klub/narocila/posodobiKontaktZaDostavoNarocila?',
          param,
          null,
          'SetNaslov',
          'ErrOdstraniKontaktZaDostavo')
      }
    },
    PredlaganiStalenNaslov (preverjanje) {
      if (preverjanje.length > 3 && preverjanje !== '') {
        let ignoredWords = []
        ignoredWords.push('^ulica')
        ignoredWords.push('^ul.')
        ignoredWords.push('^ul')
        for (let i = 0; i < ignoredWords.length; i++) {
          let reg = new RegExp(ignoredWords[i])
          if (reg.test(preverjanje)) {
            let najdenNiz = reg.exec(preverjanje)
            najdenNiz += '' + najdenNiz
            preverjanje = preverjanje.substring(najdenNiz.length - 1)
            break
          }
        }
      }
      if (preverjanje.length > 3 && preverjanje !== '') {
        this.ulice = preverjanje
        let param = ['delniNaziv=' + this.ulice]
        this.clientAgent.postWsRequest(
          this,
          'autocomplete/naslov/Naslov',
          param,
          null,
          'SetPredlaganStalenNaslov',
          'ErrPredlaganStalenNaslov')
      } else {
        this.naslovi = []
      }
    },
    SetPredlaganStalenNaslov (podatki) {
      this.naslovi = podatki.data
    },
    ErrPredlaganStalenNaslov (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowErrorMessage(paramObvestilo)
    },
    PridobiPogodbo (idNarocilo) {
      this.prenosPdf = true
      let param = ['idStranka=' + this.izbranaStranka]
      param.push('idNarocilo=' + idNarocilo)
      this.clientAgent.postWsRequest(
        this,
        'klub/narocila/pridobiPogodboNarocila',
        param,
        null,
        'SetPridobljenaPogodba',
        'ErrPridobljenaPogodba')
    },
    SetPridobljenaPogodba (podatki) {
      let vsebinaPdf = 'data:application/pdf;base64,' + podatki.data.vsebina
      const fileName = podatki.data.ime_datoteke + '.' + podatki.data.koncnica
      this.PrenesiDatoteko(vsebinaPdf, fileName)
      this.prenosPdf = false
    },
    ErrPridobljenaPogodba (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
      this.prenosPdf = false
    }
  }
}
</script>

<style scoped src="../../../../../../static/css/MojT-2/T2Klub/MojaNarocila.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Mojprofil/T2klub/MojaNarocila.vue